export class CreatePdfFreeReceiptDto {
    name?: string;
    concept?: string;
    address?: string;
    city?: string;
    amount?: number;
}
